const getProgressmatifyEditorLocalStorage = (key = false) => {
    if (!window.localStorage) {
        return null;
    }

    if (!key) {
        return localStorage;
    }

    const progressmatifySettingState = localStorage.getItem(key);

    if (progressmatifySettingState) {
        return JSON.parse(progressmatifySettingState);
    }

    return null;
};

export default getProgressmatifyEditorLocalStorage;
